<template>
    <div class="groups-tab pt-3">

        <!--<v-row class="px-3 my-1">
                    <v-col class="text-left" cols="12" md="8">
                        <div class="text-h5">
                            Groups
                        </div>
                        <div class="subtitle-1 text-left mb-4">
                            Manage your groups
                        </div>
                    </v-col>
                    <v-col cols="12" md="4">
                        <div class="d-flex justify-end">
                            <v-text-field
                                ref="ruleSearch"h
                                append-icon="mdi-magnify"
                                v-model="ruleFilterValue"
                                label="Narrow down rules"
                                clearable
                                v-if="isShowSearch && hideMobileListingForMobileIfListingItemSelected()"
                                class="search-listing-autocomplete max-width-450"
                            ></v-text-field>

                            <v-btn-toggle class="pr-2 my-1 ml-3 ">
                                <v-btn @click="toggleSearch()">
                                    <v-icon v-text="icons.mdiMagnify"></v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </div>
                    </v-col>
                </v-row>-->

        <v-row>
            <v-col :lg="currentSelectedGroupName ? 4 : 12" :md="currentSelectedGroupName ? 4 : 12"
                   :xl="currentSelectedGroupName ? 3 : 12"
                   class="border-right-divider" cols="12">

                <v-row>
                    <v-col class="grow">
                        <v-text-field
                            v-if="hideMobileListingForMobileIfListingItemSelectedForGroups() && groups.length > 0"
                            v-model="groupFilterValue"
                            :label="$gettext('Search groups')" append-icon="mdi-magnify"
                            class="search-listing-autocomplete"
                            clearable hide-details></v-text-field>
                    </v-col>
                    <v-col class="shrink">
                        <!--                        v-if="isMdAndUpOrOnTheMobileListingPage"-->
                        <v-btn-toggle :dense="$vuetify.breakpoint.smAndDown" class="text--primary">

                            <v-btn icon plain @click="openAddEditGroupDialog('', 'add')">
                                <v-icon class="my-2 mr-1 mx-auto" v-text="icons.mdiPlus"></v-icon>
                            </v-btn>

                            <v-btn
                                :title="$gettext('We can group the groups by a folder, just as we group files in a folder.')"
                                icon plain
                                @click="openAddEditFolderDialog('', 'add')">
                                <v-icon class="my-2 mr-1" v-text="icons.mdiFolderPlusOutline"></v-icon>
                            </v-btn>

                        </v-btn-toggle>

                    </v-col>
                </v-row>

                <v-divider v-if="isMdAndUpOrOnTheMobileListingPage" class="mt-5 mb-2"></v-divider>

                <v-list
                    v-if="currentViewGroupsCount()['totalCount'] > 0 && hideMobileListingForMobileIfListingItemSelectedForGroups()"
                    class="groups-tab-list v-list-wrapper"
                    dense>
                    <draggable v-model="groups" :group="{ name: 'group', pull: true, put: true, sort: true }">
                        <!--                        v-model="item.active"-->
                        <!--                        :prepend-icon="item.action"-->
                        <div v-for="group in groups" v-if="folderCondition(group) || looseGroupCondition(group)"
                             :key="group.key">

                            <v-list-group v-if="folderCondition(group)"
                                          v-model="groupFolderListing[group.key].open"
                                          :class="{ 'mb-2': isCurrentSelectedFolder(group.key) }">
                                <template v-slot:activator>
                                    <v-list-item :class="{ 'my-1': isCurrentSelectedFolder(group.key) }"
                                                 :value="group.key"
                                                 class="v-list-item-has-folder">
                                        <v-list-item-icon class="mr-6">
                                            <v-icon color="primary"
                                                    v-text="isCurrentSelectedFolder(group.key) ? icons.mdiFolderOpen : icons.mdiFolder"></v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title :class="folderNameDynamicClasses(group.key)"
                                                               class="text-left"
                                                               v-text="group.key"></v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="ma-0 px-0">
                                            <v-menu>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-bind="attrs" v-on="on">
                                                        <v-icon v-text="icons.mdiDotsVertical"></v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item @click="openAddEditFolderDialog(group.key, 'edit')">
                                                        <v-list-item-title>
                                                            <v-icon class="mr-1" size="18"
                                                                    v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                            {{ $gettext('Edit') }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item @click="deleteFolder(group.key)">
                                                        <v-list-item-title>
                                                            <v-icon class="mr-1" size="18"
                                                                    v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                            {{ $gettext('Delete') }}
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </v-list-item-action>
                                    </v-list-item>
                                </template>

                                <v-list-item-group v-model="currentSelectedGroupName">

                                    <!-- :class is required because the v-list-item-group works toggle's it's active state and we do want to lose the focus. -->

                                    <draggable v-if="group.child" v-model="group.child"
                                               :group="{ name: 'group', pull: true, put: true, sort: true }"
                                               @end="handleNestedDragEnd(group, $event)">
                                        <v-list-item v-for="child in group.child" v-show="checkEachGroup(child.key)"
                                                     :key="child.key"
                                                     :class="{ 'v-item--active v-list-item--active v-list-item-active': !!(currentSelectedGroupName && child.key && currentSelectedGroupName === child.key) }"
                                                     :value="child.key" class="body-1 ml-6"
                                                     @click="selectGroup(child.key, child.value)">
                                            <v-list-item-icon>
                                                <v-icon v-text="icons.mdiSelectGroup"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="text-left body-2">
                                                    {{ child.key }}
                                                    <icons-master v-if="child.value['@master']"
                                                                  :title="$gettext('This group is managed by organization.')"/>
                                                    <icons-updatable v-else-if="child.value['@updatable']"
                                                                     :title="$gettext('This group is managed by Lightphone. Lightphone updates this group periodically to receive new updates.')"/>
                                                </v-list-item-title>

                                            </v-list-item-content>
                                            <v-list-item-action class="my-0">
                                                <v-menu>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn icon v-bind="attrs" v-on="on">
                                                            <v-icon small v-text="icons.mdiDotsHorizontal"></v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list dense flat>
                                                        <!-- :value="child.key"-->
                                                        <v-list-item
                                                            @click="openAddEditGroupDialog(child.key, 'edit', group.key)">
                                                            <v-list-item-title>
                                                                <v-icon class="mr-1" size="18"
                                                                        v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                {{ $gettext('Edit') }}
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <!--:value="child.key"-->
                                                        <v-list-item @click="deleteGroup(child.key, group.key)">
                                                            <v-list-item-title>
                                                                <v-icon class="mr-1" size="18"
                                                                        v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                {{ $gettext('Delete') }}
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <div v-if="!group?.child?.length" class="my-2">
                                            {{ $gettext('No groups are added to this folder so far.') }} <a
                                            class="primary--text font-weight-bold text-decoration-underline"
                                            @click="openAddEditGroupDialog('', 'add')">{{ $gettext('Add a Group') }}</a>
                                        </div>
                                    </draggable>

                                </v-list-item-group>
                            </v-list-group>
                            <!-- If we do not have the not child check over here, while searching the folder, it is considered as a group-->
                            <v-list-item-group v-else-if="looseGroupCondition(group)" v-show="checkEachGroup(group.key)"
                                               v-model="currentSelectedGroupName">
                                <v-list-item
                                    :class="{ 'v-item--active v-list-item--active v-list-item-active': !!(currentSelectedGroupName && group.key && currentSelectedGroupName === group.key) }"
                                    :value="group.key"
                                    class="ml-4"
                                    @click="selectGroup(group.key, group.value)">
                                    <v-list-item-content>
                                        <v-list-item-title class="text-left body-2">
                                            <v-icon class="mr-1 primary--text" v-text="icons.mdiSelectGroup"></v-icon>
                                            {{ group.key }}
                                            <icons-master v-if="group.value['@master']"
                                                          :title="$gettext('This group is managed by organization.')"></icons-master>
                                            <icons-updatable v-else-if="group.value['@updatable']"
                                                             :title="$gettext('This group is managed by Lightphone. Lightphone updates this group periodically to receive new updates.')"></icons-updatable>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action class="my-0">
                                        <v-menu>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon v-text="icons.mdiDotsVertical"></v-icon>
                                                </v-btn>
                                            </template>

                                            <v-list dense>
                                                <v-list-item :value="group.key"
                                                             @click="openAddEditGroupDialog(group.key, 'edit')">
                                                    <v-list-item-title>
                                                        <v-icon class="mr-1" size="18"
                                                                v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                        {{ $gettext('Edit') }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="deleteGroup(group.key)">
                                                    <v-list-item-title>
                                                        <v-icon class="mr-1" size="18">
                                                            {{ icons.mdiDeleteCircleOutline }}
                                                        </v-icon>
                                                        {{ $gettext('Delete') }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list-item-group>
                        </div>
                    </draggable>
                </v-list>
                <v-row v-else-if="groupFilterValue.length > 0" class="mx-1 mt-0 mb-3">
                    <v-col>
                        {{
                            $gettextInterpolate($gettext("No matching groups found for your search: %{ groupFilterValue }"), {
                                groupFilterValue
                            })
                        }}
                    </v-col>
                </v-row>
                <v-row v-else-if="hideMobileListingForMobileIfListingItemSelectedForGroups()" class="mx-1 mt-0 mb-3">
                    <v-col>
                        {{ $gettext('We don\'t have any groups added yet.') }}
                        <v-row class="my-3">
                            <v-col>
                                <v-btn class="primary mx-2" @click.prevent="openAddEditGroupDialog('', 'add')">{{
                                        $gettext('Add Group')
                                    }}
                                </v-btn>
                                <v-btn class="primary mx-2" @click.prevent="openAddEditFolderDialog('', 'add')">{{
                                        $gettext('Add folder')
                                    }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-divider v-if="$vuetify.breakpoint.mdAndUp"></v-divider>

                <!--otherwise during search the following gets to top-->
                <v-spacer></v-spacer>

            </v-col>
            <!-- v-if="currentSelectedGroup && currentSelectedGroupName" -->
            <!--<v-col v-if="isAGroupSelected()" :lg="hasDomainSuggestions ? 3 : 7" :md="hasDomainSuggestions ? 3 : 7"
                   class="ma-3"
                   cols="12">-->
            <v-col v-if="isAGroupSelected()" :lg="7" :md="7" class="ma-3" cols="12">

                <v-row>
                    <v-col v-if="isSelectedGroupHasValue()">

                        <!-- auto-grow here causes a bug. Have a group open, go to informations tab, add a rule to group, and the textarea will have scroll, but it does not autogrow-->
                        <!--                            v-if="isAGroupSelected()"-->
                        <!--                        :value="replaceCommaWithNewLineForArray(currentSelectedGroup?.dest_domains)"-->


                        <!-- :value="currentSelectedGroup?.dest_domains" -->
                        <!--                            @input="storeBackNewLinesAsArrayElementAndUpdateSuggestions(currentSelectedGroup?.dest_domains, $event);"-->
                        <!--                        @change="forTextAreaItemsUpdateSuggestions(1)"-->

                        <v-textarea
                            ref="destDomains"
                            :disabled="currentSelectedGroup.hasOwnProperty('@master') || currentSelectedGroup.hasOwnProperty('@updatable')"
                            :label="$gettextInterpolate($gettext('Destination Domains Patterns for %{ currentSelectedGroupName }'), { currentSelectedGroupName })"
                            :value="currentSelectedGroupDestDomainsString"
                            auto-grow
                            hide-details
                            outlined
                            placeholder="*.google.com"
                            @blur="sortDestDomains()"
                            @input="storeBackNewLinesAsArrayElement($event)"
                        ></v-textarea>
                        <div v-if="currentSelectedGroup.hasOwnProperty('@master')" class="caption my-1">
                            <v-icon :title="$gettext('Edit is not allowed here')" class="mr-1" x-small
                                    v-text="icons.mdiLock"></v-icon>
                            {{ $gettext('This group is managed by your organization.') }}
                        </div>
                        <div v-if="currentSelectedGroup.hasOwnProperty('@updatable')" class="caption mb-1">

                            <!--                            content-class="pa-0 ma-0"-->
                            <v-tooltip>
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="my-1">
                                        <v-icon :title="$gettext('Edit is not allowed here')" class="mr-1" x-small
                                                v-text="icons.mdiPencilOffOutline"></v-icon>
                                        {{ $gettext('This group is managed by Lightphone. Learn more about this') + ' ' }}
                                        <a v-bind="attrs" v-on="on">{{ $gettext('here') }}</a>
                                    </div>
                                </template>
                                <span>
                                    {{
                                        $gettext('Groups managed by Lightphone are mostly programs like antivirus, Skype, etc. When we find that let\'s say a new Antivirus is added, we update this list here.')
                                    }}
                                </span>
                                <!--                                <v-card>
                                                                    <v-card-title>
                                                                        {{ $gettext('Why & how do Sheltercom manages this?') }}
                                                                    </v-card-title>
                                                                    <v-card-text>
                                                                        {{
                                                                            $gettext('Groups managed by Sheltercom are mostly programs like antivirus, Skype, etc. When we find that let\'s say a new Antivirus is added, we update this list here. The group typically receives a weekly update.')
                                                                        }}
                                                                    </v-card-text>
                                                                </v-card>-->

                            </v-tooltip>

                        </div>

                        <!--v-if="isAGroupSelected()"-->
                        <div class="text-h5 text-left">
                            <v-icon class="mx-1 primary--text" v-text="icons.mdiSelectGroup"/>
                            {{ currentSelectedGroupName }}
                        </div>
                    </v-col>
                    <v-col v-else>
                        <span class="my-2">
                            {{ $gettext('No group is selected yet. Would you like to add a group?') }}

                            <div class="my-6">
                                <v-btn class="primary" small @click="openAddEditGroupDialog('', 'add')">
                                    {{ $gettext('Add Group') }}
                                </v-btn>
                            </div>
                        </span>
                    </v-col>
                </v-row>
                <v-row v-if="comingFrom && isAGroupSelected()">
                    <v-col>
                        <v-btn v-if="comingFrom === 'internetFilterTab'" class="primary mx-2"
                               @click="backToInternetFilterTab()">
                            <v-icon class="mx-1" v-text="icons.mdiArrowLeftCircle"></v-icon>
                            {{ $gettext('Back to Rules') }}
                        </v-btn>
                        <v-btn class="primary mx-2" @click="deleteGroup(currentSelectedGroupName)">
                            <v-icon class="mx-1" v-text="icons.mdiDeleteForever">
                            </v-icon>
                            {{ $gettext('Delete') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <!-- Suggestions functionality commented out -->
            <!--<v-col v-if="hasDomainSuggestions" cols="12" lg="4" md="4">
                <v-row class="text-h5 text-left">
                    <v-col>
                        {{ $gettext('Suggestions') }}
                        <v-icon class="mx-2" v-text="icons.mdiAutoFix"></v-icon>
                        <div class="subtitle-1 my-2">{{
                                $gettext('Recommended for smooth functioning of the following websites:')
                            }}
                        </div>
                    </v-col>
                </v-row>

                <v-row class="text-left">
                    <v-col v-for="(domainAndSuggestions, index) in domainSuggestions"
                           v-if="domainAndSuggestions.suggestions.length > 0" class="" cols="12"
                           lg="6">

                        <v-card :elevation="isDark ? 5 : 2" class="" rounded>
                            <v-card-title class="justify-center text-h6 font-weight-thin">{{
                                    domainAndSuggestions.domain
                                }}
                            </v-card-title>
                            <v-card-text>

                                <v-chip v-for="(suggestionDomain) in domainAndSuggestions.suggestions"
                                        v-if="!isDomainPresentInTextArea(suggestionDomain)"
                                        :key="suggestionDomain" class="mx-1 mb-4"
                                        @click="addGroupToDestDomains(suggestionDomain)" v-text="suggestionDomain">
                                </v-chip>
                            </v-card-text>

                        </v-card>
                    </v-col>
                </v-row>
            </v-col>-->
        </v-row>

        <v-row class="text-right">
            <v-col>
                <small>
                    <!--                    {{ $gettext('Groups:') }}-->
                    <!--                    {{ getGroupCountWithFilter() }}-->
                </small>
            </v-col>
        </v-row>

        <!------------------------------------------------
            Dialogs
        ------------------------------------------------->

        <dialog-groups-add-edit-group v-if="addEditGroupDialog"
                                      :add-edit-group-default-folder="addEditGroupDefaultFolder"
                                      :add-edit-group-dialog="addEditGroupDialog"
                                      :add-edit-group-folder-prop="editGroupFolderField"
                                      :groups-prop="groups"
                                      :in-edit-group-name="editGroupNameField"
                                      :mode="addEditGroupMode"
                                      @close-add-edit-group-dialog="(dialogName) => { closeDialog(dialogName) }"
                                      @group-added="(groupToSave, folderName) => { processAddAGroup(groupToSave, folderName) }"
                                      @group-updated="(groupToUpdate, folderName) => { processEditAGroupName(groupToUpdate, folderName) }">
        </dialog-groups-add-edit-group>
        <dialog-groups-add-edit-folder
            v-if="addEditFolderDialog" :add-edit-folder-dialog="addEditFolderDialog"
            :groups-prop="groups"
            :in-edit-folder-name="editFolderNameField"
            :mode="addEditFolderMode"
            @close-add-edit-folder-dialog="(dialogName) => { closeDialog(dialogName) }"
            @folder-added="(folderToSave) => { processAddAGroup(folderToSave, '', 'folder') }"
            @folder-updated="(folderToSave) => { processEditAFolderName(folderToSave) }">
        </dialog-groups-add-edit-folder>

        <!------------------------------------------------
            Snackbar
        ------------------------------------------------->

        <snackbar ref="snackbar"></snackbar>

    </div>
</template>
<script>
import Vue from 'vue'
import {debounce, findIndex, uniq} from 'lodash'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinConfig from '@/mixins/database/MixinConfig'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import {useGroupsStore} from '@/stores/GroupsStore'
import {mapWritableState} from 'pinia'
import draggable from 'vuedraggable'
import MixinListing from '@/mixins/listing/MixinListing'
import DialogGroupsAddEditGroup from '@/components/dialogs/groups/DialogGroupsAddEditGroup'
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import MixinGenericHelper from '@/mixins/generic/MixinGenericHelper'
import FilterConvertArrayToStringWithNewLineForEachElement
    from '@/filters/FilterConvertArrayToStringWithNewLineForEachElement'
import DialogGroupsAddEditFolder from "@/components/dialogs/groups/DialogGroupsAddEditFolder.vue";
import Constants from '@/assets/js/constants'
import axios from "axios";
import MixinDark from "@/mixins/database/MixinDark";
import IconsMaster from "@/components/blocks/icons/IconsMaster.vue";
import IconsUpdatable from "@/components/blocks/icons/IconsUpdatable.vue";
import constants from "@/assets/js/constants";

Vue.use(VueSweetalert2)

export default {
    name: 'GroupsTab',
    components: {
        IconsUpdatable,
        IconsMaster,
        DialogGroupsAddEditFolder,
        Snackbar,
        draggable,
        DialogGroupsAddEditGroup
    },
    mixins: [MixinDialog, MixinIcon, MixinConfig, MixinSwalConfirmation, MixinStringManipulation, MixinListing, MixinGenericComponent, MixinGenericHelper, MixinDark],
    watch: {
        /* Suggestions functionality commented out */
        /*domainSuggestions: {
            handler: function (val, oldVal) {

            },
            deep: true
        },*/
        groupFolderListing: {
            handler: function (val, oldVal) {

            },
            deep: true
        },
        groupFilterValue: {

            handler: function (val, oldVal) {

                let self = this;

                if (val) {

                    let folders = [];

                    self.groups.forEach(g => {
                        if (g.hasOwnProperty('child') && self.checkEachFolder(g.child)) {
                            folders.push(g.key)
                        }
                    })

                    if (folders.length === 1) {
                        self.groupFolderListing[folders[0]]['open'] = true;
                    }

                }

                /**
                 * When the search is cleared via x (clearable), a scroll was introduced, this is to remove that scroll
                 */
                if (oldVal?.length && !val) {
                    self.setHeightForListingBox()
                }

            },
            deep: true
        },

        currentSelectedGroup: {
            handler: function (group) {
                let self = this

                if (group) {

                    // self.currentSelectedGroup.dest_domains = group.dest_domains.toString().replaceAll(',', '\n');
                    let dd = JSON.parse(JSON.stringify(group?.dest_domains));
                    self.currentSelectedGroupDestDomainsString = dd.toString().replaceAll(',', '\n');

                    // if group is string convert to array
                    if (typeof group.dest_domains === 'string' && group.dest_domains.indexOf('\n') > -1) {
                        // self.currentSelectedGroup.dest_domains = g.replaceAll('\n', ',').split(',');
                        Vue.set(self.currentSelectedGroup, 'dest_domains', dd.replaceAll('\n', ',').split(','))
                    }

                }

            },
            deep: true
        },
        currentSelectedGroupName: {
            handler: function (groupName) {

                let self = this

                self.$nextTick(function () {

                    let index = self.getCurrentSelectedIndexForGroups();

                    /**
                     * Because when the edit is tapped for the group, the currentSelectedGroupName is set but not the currentSelectedGroup
                     * self.groups[index].value !== self.currentSelectedGroup is important because there is a lack of sync with the currentSelectedGroupName pointing to the latest as it received the value with the edit but the currentSelectedGroup is not updated yet
                     */
                    if (index > -1 && (!self.currentSelectedGroup || self.groups[index].value !== self.currentSelectedGroup)) {
                        self.currentSelectedGroup = self.groups[index].value;
                    }

                    /* Suggestions functionality commented out */
                    /*self.$nextTick(function () {
                        self.domainSuggestions = [];
                        self.forTextAreaItemsUpdateSuggestions()
                    })*/


                })

            },
            deep: true
        },


    },
    data() {
        return {

            groupFilterValue: '',

            // Dialogs
            addEditFolderDialog: false,
            addEditFolderMode: 'add',
            editFolderNameField: '',
            editGroupFolderField: '',
            addEditGroupDialog: false,
            addEditGroupMode: 'add',
            addEditGroupDefaultFolder: '',
            editGroupNameField: '',
            destDomainHolder: '',

            comingFrom: '',
            groupFolderListing: {},

            /**
             * This will be an array of objects.
             * Expected format: [{domain: 'vuejs.org', suggestions: []}]
             * Suggestions functionality commented out - keeping empty array to avoid undefined references
             */
            domainSuggestions: [],

        }
    },
    computed: {
        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
            currentSelectedGroup: 'currentSelectedGroup',
            currentSelectedGroupName: 'currentSelectedGroupName',
            currentSelectedGroupDestDomainsString: 'currentSelectedGroupDestDomainsString',
        }),
        /* Suggestions functionality commented out */
        /*hasDomainSuggestions() {

            let self = this;

            return self.domainSuggestions.some((domain) => {
                if (domain.suggestions.length > 0) {
                    return true;
                }

                return false;
            })

        },*/
        allGroups() {

            let self = this;

            let allGroupNames = [];

            self.groups.forEach((group) => {
                if (group.groupName) {
                    allGroupNames.push(group.groupName);
                }
            })

            return uniq(allGroupNames);

        },
        isMdAndUpOrOnTheMobileListingPage() {
            return (this.$vuetify.breakpoint.mdAndUp || (this.$vuetify.breakpoint.smAndDown && (!this.currentSelectedGroupName || this.currentSelectedGroupName.length === 0)))
        }
    },
    created() {
    },
    mounted() {

        let self = this
        self.setHeightForListingBox()
        // self.addGroupAttribute();
        self.subscribeToGroupsStoreAndGetChangesForFolderListing();

    },

    methods: {

        /* Suggestions functionality commented out */
        /*domainSuggestionsAreWithInLimit() {

            let self = this;

            let domainSuggestionsCount = 0;
            let maxAllowedDomainSuggestions = 40;

            if (self.$vuetify.breakpoint.smAndDown) {
                maxAllowedDomainSuggestions = 20;
            }

            self.domainSuggestions.forEach((d) => {
                domainSuggestionsCount += d.suggestions.length
            })


            return (domainSuggestionsCount < maxAllowedDomainSuggestions)

        },

        checkIfDomainSuggestionsHasGroup(groupName) {
            return this.domainSuggestions.some(item => item.domain.includes(groupName))
        },

        isDomainPresentInTextArea(domain) {

            let self = this;
            let destDomainsArray = self.$refs.destDomains?.value?.split('\n');
            return destDomainsArray?.includes(domain)

        },*/

        /**
         * For each domain pattern in the textarea, we will get and set suggestions for it. One by one.
         *
         * @returns {void}
         */
        /*forTextAreaItemsUpdateSuggestions(resetSuggestions = false) {

            let self = this;

            if (resetSuggestions) {
                self.domainSuggestions = [];
            }

            self.$nextTick(function () {

                let lines = self.$refs.destDomains?.value?.split('\n');
                lines?.forEach((line) => {
                    if (line.length > 0) {
                        self.setSuggestionsForGroups(line);
                    }
                })

                const sortDomainSuggestionsByKeyDomain = () => {
                    self.domainSuggestions.sort((a, b) => {
                        return a.domain.localeCompare(b.domain);
                    }) // so this brings domains in alphabetical order, not the suggestions
                }

                const sortSuggestionsInsideDomainSuggestions = () => {
                    self.domainSuggestions.forEach((item) => {
                        item.suggestions.sort((a, b) => {
                            return a.localeCompare(b);
                        })
                    }) // Sort domainSuggestions array, foreach domain, sort the suggestions
                }

                self.$nextTick(function () {
                    sortDomainSuggestionsByKeyDomain();
                    self.$nextTick(function () {
                        sortSuggestionsInsideDomainSuggestions();
                    })
                })

            })


        },*/

        addGroupToDestDomains(groupName) {

            let self = this;
            // let destDomainsArray = JSON.parse(JSON.stringify(self.currentSelectedGroup.dest_domains.split('\n')));
            self.currentSelectedGroup.dest_domains.push(groupName);
            // self.currentSelectedGroup.dest_domains = destDomainsArray.join('\n');
            // focusOnTheDestDomainTextArea()

            /* this.$refs.destDomains.focus();
            this.$refs.destDomains.blur();
            this.$refs.destDomains.focus(); */

            /* Suggestions functionality commented out */
            // self.forTextAreaItemsUpdateSuggestions(1);

        },

        /* Suggestions functionality commented out */
        /*async setSuggestionsForGroups(groupName) {

            let self = this;

            if (self.domainSuggestions.length > 3) {
                return false;
            }

            if (!self.checkIfDomainSuggestionsHasGroup(groupName)) {

                try {

                    let foundInSs = false;

                    let groupsSuggestionsArrayFromSs = sessionStorage.getItem('groupsSuggestions');
                    if (groupsSuggestionsArrayFromSs && groupsSuggestionsArrayFromSs.length > 0 && groupsSuggestionsArrayFromSs !== '{}') {
                        groupsSuggestionsArrayFromSs = JSON.parse(groupsSuggestionsArrayFromSs);
                        groupsSuggestionsArrayFromSs.forEach((item) => {
                            if (item.domain === groupName) {
                                self.domainSuggestions.push(item)
                                foundInSs = true;
                            }
                        })
                    }

                    if (!foundInSs) {

                        if (!self.domainSuggestionsAreWithInLimit()) {
                            return false;
                        }


                        let groupsSuggestionsRequest = await axios.get('groups.php?domain=' + groupName + '&action=getDomainSuggestions')
                        let groupsSuggestions = []

                        let domainSuggestions = false;

                        if (typeof groupsSuggestionsRequest.data === 'object') {

                            let domainSuggestionsFromServer = groupsSuggestionsRequest.data?.data?.domainSuggestions;

                            if (domainSuggestionsFromServer) {

                                try {
                                    // FIXME: REMOVE THIS
                                    console.log('domainSuggestionsFromServer', domainSuggestionsFromServer);
                                    domainSuggestions = JSON.parse(domainSuggestionsFromServer);
                                } catch (error) {
                                    domainSuggestions = false;
                                    // console.log(error)
                                }

                                if (domainSuggestions) {

                                    for (let group in domainSuggestions) {

                                        if (Array.isArray(domainSuggestions[group])) {
                                            domainSuggestions[group].forEach((g) => {
                                                groupsSuggestions.push(g)
                                            })
                                        }

                                    }

                                }

                            }


                        }


                        if (domainSuggestions) {

                            let suggestionToBeInserted = {
                                domain: groupName,
                                suggestions: groupsSuggestions
                            };

                            self.domainSuggestions.push(suggestionToBeInserted)

                            if (groupsSuggestionsArrayFromSs && groupsSuggestionsArrayFromSs.length > 0 && groupsSuggestionsArrayFromSs !== '{}') {
                                groupsSuggestionsArrayFromSs.push(suggestionToBeInserted)
                                sessionStorage.setItem('groupsSuggestions', JSON.stringify(groupsSuggestionsArrayFromSs));
                            } else {
                                sessionStorage.setItem('groupsSuggestions', JSON.stringify(self.domainSuggestions));
                            }

                        }

                    }

                } catch (error) {
                    console.log(error)
                }

            }

            self.removeFromAllSuggestionsTheGroupsAlreadyAdded()


        },

        removeFromAllSuggestionsTheGroupsAlreadyAdded() {

            let self = this;

            self.domainSuggestions.map((suggestion, key) => {

                let destDomainsArray = self.$refs.destDomains.value?.split('\n');

                suggestion.suggestions = suggestion.suggestions.filter((suggestionDomain) => !destDomainsArray.includes(suggestionDomain))

                return suggestion;

            });

        },*/

        handleNestedDragEnd(group, event) {
            const {newIndex, oldIndex} = event;
        },
        handleDragEnd(event) {
            const {newIndex, oldIndex} = event;
        },

        isSelectedGroupHasValue() {
            return this.currentSelectedGroup && this.currentSelectedGroup.hasOwnProperty('dest_domains')
        },
        isAGroupSelected() {
            return (this.currentSelectedGroupName && this.currentSelectedGroupName.length > 0)
        },
        folderCondition(group) {

            let self = this;

            const isGroupChildExists = group.hasOwnProperty('child') && group.child;
            const isEachFolderChecked = this.checkEachFolder(group.child);
            const isGroupFolderListing = this.groupFolderListing;
            const hasGroupFolderListingEntries = isGroupFolderListing && Object.entries(isGroupFolderListing).length > 0;
            const hasGroupKey = isGroupFolderListing && isGroupFolderListing[group.key];
            const hasGroupKeyOpen = hasGroupKey && hasGroupKey.hasOwnProperty('open');

            return (isGroupChildExists && isEachFolderChecked && hasGroupFolderListingEntries && hasGroupKey && hasGroupKeyOpen)

        },

        /**
         * This is for the groups that are at root level, not nested inside any folder
         * @param group
         * @returns {boolean}
         */
        looseGroupCondition(group) {
            return (!group.hasOwnProperty('child'))
        },

        syncFolderGroups() {

            let self = this;

            let folderThatWasOpen = false;

            for (let i in self.groupFolderListing) {
                if (self.groupFolderListing[i]['open'] && !folderThatWasOpen) {
                    folderThatWasOpen = i;
                }
            }

            /**
             * Otherwise, when we delete the groups, the folder listing is not updated.
             */
            self.groupFolderListing = {};

            self.groups.forEach((group) => {

                if (group.hasOwnProperty('child')) {

                    let groupKey = group.key;

                    if (-1 === findIndex(self.groupFolderListing, groupKey)) {
                        Vue.set(self.groupFolderListing, groupKey, {open: groupKey === folderThatWasOpen})
                    }

                }

            })
        },

        subscribeToGroupsStoreAndGetChangesForFolderListing() {

            let self = this;

            useGroupsStore().$subscribe((mutation, state) => {
                self.syncFolderGroups();
            })

            self.syncFolderGroups();

        },

        folderNameDynamicClasses(folderName) {

            return {
                'text-h6 font-weight-light': this.isCurrentSelectedFolder(folderName),
                'subtitle-1': !this.isCurrentSelectedFolder(folderName)
            }

        },

        isCurrentSelectedFolder(folderName) {
            return this.getCurrentSelectedFolder() === folderName
        },

        /**
         *
         * @returns {*|boolean}
         */
        getCurrentSelectedFolder() {

            let self = this;
            let currentGroup = false;

            for (let folder in self.groupFolderListing) {

                if (self.groupFolderListing[folder].open && !currentGroup) {
                    currentGroup = folder;
                }

            }

            return currentGroup;

        },

        /**
         * not in use
         * @returns {boolean}
         */
        isCurrentSelectedGroupUnderTheOpenFolder() {

            let self = this;
            let folder = self.getCurrentSelectedFolder();

            if (folder?.length > 0) {

                let groupRow = self.groups.find(g => g.key === folder);

                if (groupRow?.child.filter(gc => gc.key === self.currentSelectedGroupName)['length']) {
                    return true;
                }

            }

            return false;

        },

        addGroupAttribute() {

            let self = this

            self.groups = self.groups.map((group) => {

                let indexOfSlash = group.key.indexOf('/');
                if (indexOfSlash !== -1) {
                    group.groupName = group.key.substring(0, indexOfSlash);
                    group.groupItemName = group.key.substring(indexOfSlash + 1);
                }

                return group

            })

        },

        getGroupCountWithFilter() {

            let self = this

            let totalCount = Object.entries(self.groups).length;
            let filteredCount = self.groups.filter((group) => self.checkEachGroup(group.key)).length

            return totalCount !== filteredCount ? filteredCount + '/' + totalCount : totalCount

        },

        /**
         * This considers search parameter/filter as well
         * @returns {boolean}
         */
        currentViewGroupsCount() {

            let self = this

            let groupCount = 0
            let folderCount = 0
            let totalCount = 0

            if (self.groups.length > 0) {

                self.groups.forEach((group) => {

                    this.folderCondition(group, 'currentViewGroupsCount') ? folderCount++ : ''

                    if (group.hasOwnProperty('child')) {
                        group.child.forEach((childGroup) => {
                            this.checkEachGroup(childGroup.key) ? groupCount++ : ''
                        })
                    } else {
                        this.checkEachGroup(group.key) ? groupCount++ : ''
                    }

                })

            }

            return {
                groupCount: groupCount,
                folderCount: folderCount,
                totalCount: groupCount + folderCount
            }

        },

        convertArrayToStringWithNewLineForEachElement: function (array) {
            return array.toString().replaceAll(',', '\n')
        },
        backToInternetFilterTab() {

            let self = this
            let homeComponent = self.genericComponentGetComponent('Home')
            homeComponent.currentTab = constants.rulesTabIndex
            self.resetComingFrom();

        },

        /**
         * This is important because otherwise, we create a new group, and next we will see, go back to Rules, which is not applicable but only for immediate back action when visiting from the internet filter tab.
         */
        resetComingFrom() {
            let self = this
            self.comingFrom = ''
        },

        clearCurrentSelectedGroup() {

            let self = this
            self.currentSelectedGroupName = ''
            self.currentSelectedGroup = ''

        },

        /**
         * If we do not do this, when a drag and drop is to occur the changes are not pushed to store and hence not saved.
         * This helps.
         */
        syncGroups() {

            let self = this

            const groupsStore = useGroupsStore()
            groupsStore.setGroups(self.groups)

        },

        replaceCommaWithNewLineForArray(str) {

            if (str && str.length > 0) {
                return str.toString().replaceAll(',', '\n')
            }
            return ''

        },

        storeBackNewLinesAsArrayElement(str) {

            let self = this
            self.currentSelectedGroup.dest_domains = str.replaceAll('\n', ',').split(',')
            /* Suggestions functionality commented out */
            // self.debounceForTextAreaItemsUpdateSuggestions()

        },

        sortDestDomains() {

            let self = this

            // The auto-grow was hiding the last line without setTimeout
            setTimeout(async () => {
                self.currentSelectedGroup.dest_domains.sort();
            }, 600)

        },

        /* Suggestions functionality commented out */
        /*debounceForTextAreaItemsUpdateSuggestions: debounce(function () {
            this.forTextAreaItemsUpdateSuggestions(1); // The only advantage of reset here is, if let's say the user deleted an entry, then the suggestions gets deleted with it as well.
        }, 500),*/

        beforeSelectingGroup() {

            // This set up is for an edge case scenario.
            // i.e. when a group is selected, add another group, the active is properly removed from older one and set to new one.
            // but when adding again, the first item and the new items both are highlighted, the following code ensures the first entry is deleted.
            jQuery('.groups-tab-list .v-item--active').removeClass('v-item--active')
            jQuery('.groups-tab-list .v-list-item--active').removeClass('v-list-item--active')
            jQuery('.groups-tab-list .v-list-item-active').removeClass('v-list-item-active')

        },

        selectGroup(groupName, groupValue) {

            let self = this

            self.beforeSelectingGroup();
            self.resetComingFrom();

            self.$nextTick(() => {
                self.currentSelectedGroup = groupValue
                self.currentSelectedGroupName = groupName
            })

            // The v-list-item-group's model gets reset to empty when click twice, as it toggles the value. Since we do not wish to toggle the value, we set it manually back again with the $nextTick where setTimeout is a safety net. We have this similar code block for ProfileApplicationTab and GroupsTab
            setTimeout(() => {
                self.currentSelectedGroup = groupValue
                self.currentSelectedGroupName = groupName
            }, 300)

        },

        checkEachFolder(folderChild) {

            let self = this
            let folderVisibility = true;

            if (self.groupFilterValue && self.groupFilterValue.length > 0) {

                folderVisibility = false

                if (folderChild && folderChild.length > 0) {

                    folderChild.forEach((group) => {
                        if (group && group?.key.toLowerCase().indexOf(self.groupFilterValue.toLowerCase()) > -1 && !folderVisibility) {
                            folderVisibility = true
                        }
                    })

                }

            }

            return folderVisibility

        },

        checkEachGroup(groupName) {

            let self = this
            let groupVisibility = true

            if (self.groupFilterValue && self.groupFilterValue.length > 0) {

                groupVisibility = false

                if (groupName && groupName?.toLowerCase().indexOf(self.groupFilterValue.toLowerCase()) > -1) {
                    groupVisibility = true
                }

            }

            return groupVisibility

        },

        groupSelectedForMobile() {
            let self = this

            // extra lines to increase readability.
            return (
                self.$vuetify.breakpoint.smAndUp

                ||

                (
                    self.$vuetify.breakpoint.mobile &&
                    (
                        self.currentSelectedGroupName === '' || self.currentSelectedGroupName === false || self.currentSelectedGroupName.length === 0
                    )
                )
            )
        },

        /*---------------------------------------------
            Popup/Dialogs Methods
        ----------------------------------------------*/

        deleteFolder(folderName) {

            let self = this

            let deleteGroup = function (s) {

                let index = findIndex(s.groups, val => val.key === folderName)

                if (index !== -1) {

                    // This is a solution to a bit of an edge case scenario.
                    // If the searched user is deleted, we want to reset the search.
                    if (s.groupFilterValue === folderName) {
                        // Why are we resetting? Because if the searched element is deleted. The search field should then be reset.
                        s.groupFilterValue = ''
                    }

                    s.groups.splice(index, 1)

                    // Now that the element is deleted let's select next group, for last element select previous group.
                    // If currentSelectedGroup is not selected, then the right pane of dest domains is not activated yet, if we make a selection, it will be activated. It would be incorrect to do so. Having said that if a group was selected, we must select the next group.
                    if (self.currentSelectedGroup) {

                        if (s.groups.length > 0) {
                            if (index === s.groups.length) {
                                index--
                            }
                            s.selectGroup(s.groups[index].key, s.groups[index].value)
                        } else {
                            s.clearCurrentSelectedGroup()
                        }

                    }

                    return true
                }

                return false

            }

            let swalOptions = {
                title: self.$gettext('Delete Folder'),
                description: self.$gettextInterpolate(self.$gettext('Are you sure, you want to delete the folder, %{ groupName }?'), {groupName: folderName}),
                successCallback: deleteGroup,
                confirmButtonText: self.$gettext('Delete it!'),
                icon: 'warning',
                successText: self.$gettextInterpolate(self.$gettext('Folder %{ groupName }, is Deleted Successfully!'), {groupName: folderName}),
            }

            self.swalConfirmation(swalOptions)

        },

        deleteGroup(groupName, folderName = '') {

            let self = this

            let deleteGroup = function (s) {

                let index;
                let folderIndex
                if (folderName) {
                    folderIndex = findIndex(s.groups, val => val.key === folderName)
                    index = findIndex(s.groups[folderIndex]['child'], val => val.key === groupName)
                } else {
                    index = findIndex(s.groups, val => val.key === groupName)
                }


                if (index !== -1) {

                    // This is a solution to a bit of an edge case scenario.
                    // If the searched user is deleted, we want to reset the search.
                    if (s.groupFilterValue === groupName) {
                        // Why are we resetting? Because if the searched element is deleted. The search field should then be reset.
                        s.groupFilterValue = ''
                    }

                    if (folderName) {
                        s.groups[folderIndex]['child'].splice(index, 1)
                    } else {
                        s.groups.splice(index, 1)
                    }

                    // Now that the element is deleted let's select next group, for last element select previous group.
                    if (!folderName) {
                        if (s.groups.length > 0) {
                            if (index === s.groups.length) {
                                index--
                            }
                            s.selectGroup(s.groups[index].key, s.groups[index].value)
                        } else {
                            s.clearCurrentSelectedGroup()
                        }

                    } else {

                        if (s.groups[folderIndex]['child'].length > 0) {
                            if (index === s.groups[folderIndex]['child'].length) {
                                index--
                            }
                            s.selectGroup(s.groups[folderIndex]['child'][index].key, s.groups[folderIndex]['child'][index].value)
                        } else {
                            s.clearCurrentSelectedGroup()
                        }

                    }

                    return true
                }

                return false

            }

            let swalOptions = {
                title: self.$gettext('Delete Group'),
                description: self.$gettextInterpolate(self.$gettext('Are you sure, you want to delete %{ groupName } group?'), {groupName}),
                successCallback: deleteGroup,
                confirmButtonText: self.$gettext('Delete it!'),
                icon: 'warning',
                successText: self.$gettextInterpolate(self.$gettext('Group %{ groupName } Deleted Successfully!'), {groupName}),
            }

            self.swalConfirmation(swalOptions)

        },

        async openAddEditGroupDialog(groupName, mode, folderName = '') {

            let self = this
            self.addEditGroupDialog = true
            self.addEditGroupMode = mode
            self.addEditGroupDefaultFolder = self.getCurrentSelectedFolder()
            self.editGroupFolderField = folderName
            self.editGroupNameField = groupName

            if (groupName && groupName.length > 0) {
                await self.$nextTick()
                await self.$nextTick() // safer side
                self.currentSelectedGroupName = groupName // helps maintain the current status of the selected item in the list
            }

        },

        openAddEditFolderDialog(folderName, mode) {

            let self = this
            self.addEditFolderDialog = true
            self.addEditFolderMode = mode

            self.editFolderNameField = folderName

        },

        processEditAGroupName(newGroupName, folderName = '') {

            let self = this
            let folderIndex = findIndex(self.groups, {'key': folderName})
            self.resetComingFrom()

            if (folderIndex !== -1) {

                let oldFolderIndex = findIndex(self.groups, {key: self.editGroupFolderField})
                let groupToMove;

                function updateGroupName() {
                    let groupIndex = findIndex(self.groups[folderIndex].child, {key: self.editGroupNameField})
                    if (groupIndex !== -1) {
                        self.groups[folderIndex].child[groupIndex]['key'] = newGroupName
                    }
                }

                if (oldFolderIndex === -1) {

                    // since groups is manipulated, get new index again
                    // folderIndex = findIndex(self.groups, {'key': folderName})
                    let groupIndex = findIndex(self.groups, {key: self.editGroupNameField})

                    // insert new
                    self.groups[folderIndex]['child'].push({
                        key: newGroupName,
                        value: self.groups[groupIndex].value
                    })

                    // delete old entry
                    groupIndex = findIndex(self.groups, {key: self.editGroupNameField})

                    if (groupIndex !== -1) {
                        self.groups.splice(groupIndex, 1)
                    }

                } else if (oldFolderIndex !== folderIndex) {

                    let index = findIndex(self.groups[oldFolderIndex].child, {key: self.editGroupNameField})

                    if (index !== -1) {
                        groupToMove = self.groups[oldFolderIndex].child[index]
                        self.groups[oldFolderIndex].child.splice(index, 1)

                        // since groups is manipulated, get new index again
                        folderIndex = findIndex(self.groups, {'key': folderName})


                        self.groups[folderIndex].child.push(groupToMove)
                    }

                    updateGroupName();
                    /*else {
                    let index = findIndex(self.groups[folderIndex].child, {key: self.editGroupNameField})
                    if (index !== -1) {
                        self.groups[folderIndex].child.splice(index, 1)
                    }
                }*/
                } else {
                    updateGroupName()
                }

                self.selectGroup(newGroupName, self.groups[folderIndex].child[findIndex(self.groups[folderIndex].child, {key: newGroupName})].value)

            } else {

                // move from old folder to the root
                let oldFolderIndex = findIndex(self.groups, {key: self.editGroupFolderField})
                let groupToMove;

                if (oldFolderIndex !== -1) {
                    let index = findIndex(self.groups[oldFolderIndex].child, {key: self.editGroupNameField})
                    if (index !== -1) {
                        groupToMove = self.groups[oldFolderIndex].child[index]
                        self.groups[oldFolderIndex].child.splice(index, 1)
                        self.groups.push(groupToMove)


                        // update the new group name now

                        let index2 = findIndex(self.groups, {key: self.editGroupNameField})
                        if (index2 !== -1) {
                            self.groups[index2]['key'] = newGroupName
                        }

                        self.selectGroup(newGroupName, self.groups[index2].value)

                    }
                } else {

                    let index = findIndex(self.groups, {key: self.editGroupNameField})
                    if (index !== -1) {
                        self.groups[index]['key'] = newGroupName
                    }

                    self.selectGroup(newGroupName, self.groups[index].value)

                }
            }

            if (self.groupFilterValue === self.editGroupNameField) {
                self.groupFilterValue = newGroupName
            }

            const groupsStore = useGroupsStore()
            groupsStore.sortGroups()

            self.$refs.snackbar.showSnackbar(self.$gettext('Group updated successfully'))

        },

        getCurrentSelectedIndexForGroups() {
            let self = this
            return findIndex(self.groups, {key: self.currentSelectedGroupName})
        },

        processEditAFolderName(newFolderName) {

            let self = this
            let index;

            index = findIndex(self.groups, {key: self.editFolderNameField})
            const sortGroups = () => {
                const groupsStore = useGroupsStore()
                groupsStore.sortGroups()
            }

            self.resetComingFrom();

            if (index !== -1) {
                self.groups[index]['key'] = newFolderName
            }

            /*if (self.groupFilterValue === self.editFolderNameField) {
                self.groupFilterValue = newFolderName
            }*/

            // open the folder if it was open already
            if (self.groupFolderListing[self.editFolderNameField]['open']) {
                setTimeout(() => {
                    self.groupFolderListing[newFolderName] = {open: true}
                    sortGroups();
                }, 200)
            } else {
                sortGroups();
            }


            self.$refs.snackbar.showSnackbar(self.$gettext('Folder updated successfully'))

        },

        /**
         * Also adds a folder, the parameter is different in both cases.
         * @param groupToSave
         * @param folderName
         * @param entity
         */
        processAddAGroup(groupToSave, folderName = '', entity = 'group') {

            let self = this

            self.resetComingFrom()

            if (entity === 'folder') {

                let nextAction = groupToSave.nextAction;
                delete groupToSave.nextAction;

                // This is required for v-model of groupFolderListing, it expects the property open to be set
                self.groupFolderListing[groupToSave.key] = {open: true}

                if (nextAction) {
                    self.openAddEditGroupDialog('', 'add', groupToSave.key)
                }

            }

            let getCurrentIndex = self.getCurrentSelectedIndexForGroups()
            let folderNameIndex = findIndex(self.groups, {key: folderName})

            if (folderNameIndex !== -1) {
                self.groups[folderNameIndex].child.push(groupToSave)
            } else {
                if (getCurrentIndex !== -1) {
                    self.groups.splice(getCurrentIndex + 1, 0, groupToSave)
                } else {
                    self.groups.push(groupToSave)
                }
            }

            if (self.groupFilterValue) {
                self.groupFilterValue = ''
            }

            if (entity === 'group') {
                self.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Group added successfully. Please enter the destination domains for the group %{ groupName }.'), {groupName: groupToSave.key}), 'success', 'bottom-end', 5000)
            } else {
                self.$refs.snackbar.showSnackbar(self.$gettext('Folder added successfully'))
            }


            setTimeout(() => {

                const groupsStore = useGroupsStore()
                groupsStore.sortGroups()

                self.selectGroup(groupToSave.key, groupToSave.value)

                /* needs sometime after selectGroup */
                setTimeout(() => {

                    self.$refs.destDomains.focus()
                    smoothScrollIntoView(document.querySelector('.groups-tab-list .v-item--active'), {behavior: 'smooth'})

                }, 100)

            }, 100)

        },
    },
}
</script>

<style type="text/scss">
.border-right-divider {
    border-right: 1px solid #e0e0e0;
}

.groups-tab-list .v-list-item {
    min-height: 35px;
}

.groups-tab {


    .v-list-item {
        padding-right: 0;
    }

    .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),
    .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),
    .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
        margin-left: 0 !important;
    }

    .v-list-group__header__append-icon {
        margin-left: 0 !important;
    }


    .v-list-group,
    .v-list-group__header,
    .v-list-item__icon.v-list-group__header__append-icon,
    .v-list-item__icon,
    .v-list-group__header__append-icon,
    .v-list-item__icon,
    .v-list-group__header__append-icon,
    .v-list-item__icon,
    .v-list-group__header__append-icon,
    .v-list-item__icon .v-list-group__header__append-icon {
        min-width: 24px !important;


        //width: 24px !important; margin-left: 0 !important;
    }

    .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
        min-width: 24px !important;
    }

    .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),
    .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),
    .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child),
    .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
        margin-left: 0 !important;
    }

    .v-list,
    .v-list-item__title,
    .text-left,
    .text-h6,
    .font-weight-light {
        transition: all 0.1s ease-in-out;
        -webkit-transition: all 0.1s ease-in-out;
        -moz-transition: all 0.1s ease-in-out;
        -o-transition: all 0.1s ease-in-out;
    }

}

.groups-tab .v-list-group,
.groups-tab .v-list-group__header,
.groups-tab .v-list-item__icon,
.groups-tab.v-list-group__header__append-icon {
    min-width: 24px !important;
}

.v-application--is-ltr .groups-tab .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-ltr .groups-tab.v-list-item__avatar:last-of-type:not(:only-child),
.v-application--is-ltr .groups-tab.v-list-item__icon:last-of-type:not(:only-child),
.v-application--is-ltr .groups-tab .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 0 !important;
}

.v-list-item-has-folder {
    padding-right: 0;
}
</style>

